export { default as downloadPNG } from '~/assets/images/download.png'
export { default as downloadWEBP } from '~/assets/images/download.webp'
export { default as downloadDePNG } from '~/assets/images/download-de.png'
export { default as downloadDeWEBP } from '~/assets/images/download-de.webp'
export { default as downloadEsPNG } from '~/assets/images/download-es.png'
export { default as downloadEsWEBP } from '~/assets/images/download-es.webp'
export { default as downloadFrPNG } from '~/assets/images/download-fr.png'
export { default as downloadFrWEBP } from '~/assets/images/download-fr.webp'
export { default as downloadHuPNG } from '~/assets/images/download-hu.png'
export { default as downloadHuWEBP } from '~/assets/images/download-hu.webp'
export { default as downloadItPNG } from '~/assets/images/download-it.png'
export { default as downloadItWEBP } from '~/assets/images/download-it.webp'
export { default as downloadJaPNG } from '~/assets/images/download-ja.png'
export { default as downloadJaWEBP } from '~/assets/images/download-ja.webp'
export { default as downloadKoPNG } from '~/assets/images/download-ko.png'
export { default as downloadKoWEBP } from '~/assets/images/download-ko.webp'
export { default as downloadPlPNG } from '~/assets/images/download-pl.png'
export { default as downloadPlWEBP } from '~/assets/images/download-pl.webp'
export { default as downloadTrPNG } from '~/assets/images/download-tr.png'
export { default as downloadTrWEBP } from '~/assets/images/download-tr.webp'
export { default as downloadPtPNG } from '~/assets/images/download-pt.png'
export { default as downloadPtWEBP } from '~/assets/images/download-pt.webp'

export const DOWNLOAD_OPTIONS = [
  'download.items.first',
  'download.items.second',
] as const

export const LOGGED_IN_AUTOMATICALLY_OPTIONS = [
  'download.secondaryItems.first',
  'download.secondaryItems.second',
  'download.secondaryItems.third',
] as const
